import IntegrationResultList from './IntegrationResultList'
import IntegrationResultShow from './IntegrationResultShow'

const PreInvoice = {
  IntegrationResultList,
  IntegrationResultShow
}

export default PreInvoice
